module.exports = __webpack_public_path__ + "static/artfulbits-se-logo-1024x1024-455d6586708dada02e7e0cbf724a844a.webp";